/**
 * @fileoverview Agent definition for the b-storyline-extractor-v1 primitive.
 *
 * Extracts B-Stories (emotional/relational subplots) using the A-Story
 * timeline as a reference anchor. Part of the split extraction pipeline.
 *
 * @category import.story.extraction
 * @type primitive
 * @see docs/story-architecture.md
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas/agent';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'b-storyline-extractor-v1',
  kind: 'primitive',
  name: 'B-Story Extractor',
  description: 'Extracts B-Stories (emotional/relational subplots) with the A-Story as reference anchor.',
  category: 'import',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-03',
    lastUpdated: '2026-03',
    taxonomyPath: 'import.story.extraction',
    usedBy: [],
    relatedAgents: ['a-storyline-extractor-v1', 'c-storyline-extractor-v1', 'storyline-extraction-pipeline-v1'],
  },
};
